import { Box, Loader, Typography } from "@braintrust/braintrust-ui-components";

type JobInterviewLoaderProps = {
  size?: number;
  subtext?: string;
  text?: string;
};

export const JobInterviewLoader = ({
  size = 50,
  subtext,
  text,
}: JobInterviewLoaderProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1,
      }}
    >
      <Loader size={size} />
      {!!text && (
        <Typography
          component="span"
          size="large"
          fontWeight={500}
          sx={{ mt: 1 }}
        >
          {text}
        </Typography>
      )}
      {!!subtext && (
        <Typography component="span" size="medium" fontWeight={400}>
          {subtext}
        </Typography>
      )}
    </Box>
  );
};
